import { render, staticRenderFns } from "./diy_expression.vue?vue&type=template&id=56ba5596&"
import script from "./diy_expression.vue?vue&type=script&lang=js&"
export * from "./diy_expression.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports